import {
  Selectors,
  openURL,
  useIsMD,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library';
import {faTimes} from '@fortawesome/pro-solid-svg-icons/faTimes';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Pressable, View} from 'native-base';

import {useGetForwardUrl} from 'hooks/useGetFowardUrl';

import {theme} from '../../../theme';

export interface PRHeaderProps {
  testID: string;
  isLoggedIn: boolean;
}

const PRHeader: React.FC<PRHeaderProps> = (props) => {
  const {testID, isLoggedIn} = props;
  const {athens, paleSky} = theme.colors;
  const isMD = useIsMD();
  const forwardUrl = useGetForwardUrl();

  const onHeaderCloseButtonPress = () => {
    if (forwardUrl) {
      openURL(forwardUrl);
    } else if (isLoggedIn) {
      openURL('./rewards');
    } else {
      openURL('/rewards/signin');
    }
  };

  return (
    <View
      pb={isMD ? undefined : '50px'}
      zIndex={999}
      testID={testID + '-header'}
    >
      <View alignItems="flex-end" height="30px">
        <Pressable
          backgroundColor={athens}
          height="30px"
          width="30px"
          justifyContent="center"
          alignItems="center"
          borderRadius="25px"
          mx="16px"
          mt="16px"
          testID={`${testID}-close-button`}
          onPress={onHeaderCloseButtonPress}
        >
          <FontAwesomeIcon
            icon={faTimes}
            color={paleSky}
            style={{fontSize: 24}}
          />
        </Pressable>
      </View>
    </View>
  );
};

export default PRHeader;
